import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk that fetches courses and merges with colleges
export const fetchAllCoursesWithColleges = createAsyncThunk(
    'courses/fetchAllCoursesWithColleges',
    async ({ allColleges }, { rejectWithValue }) => {
        try {

            await new Promise((resolve) => setTimeout(resolve, 1000)); // Force delay

            const response = await axios.get('api/v1/show_all_courses');
            const allCourses = response.data.courses || [];

            const combined = allColleges.map((college) => {
                const courses = allCourses.filter((course) => course.college_id === college.id);
                return { ...college, courses };
            });

            return { allCourses, combined };
        } catch (err) {
            console.error('Failed to fetch courses:', err);
            return rejectWithValue(err.response?.data || 'Unknown error');
        } finally {

        }
    }
);

const coursesSlice = createSlice({
    name: 'courses',
    initialState: {
        allCourses: [],
        collegesWithCourses: [],
        loading: false,
        error: null,
    },
    reducers: {
        setCollegesWithCourses(state, action) {
            state.collegesWithCourses = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllCoursesWithColleges.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllCoursesWithColleges.fulfilled, (state, action) => {
                state.loading = false;
                state.collegesWithCourses = action.payload.combined;
                state.allCourses = action.payload.allCourses
            })
            .addCase(fetchAllCoursesWithColleges.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { setCollegesWithCourses } = coursesSlice.actions;
export default coursesSlice.reducer;
